import React, { useContext, useCallback } from 'react';
import { IEditorProps } from './Editor';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import './ArrayEditor.less';
import {
  insertRowAtViaContextId,
  insertColumnAtViaContextId,
} from '@decisions/server/DecisionsFramework/Design/Form/FormDesignerService';

import './LayoutEntityEditor.less';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { ActionsProps } from './ArrayListItem';
import { ArrayEditor } from './ArrayEditor';
import { InsertColumnRowAt } from '@decisions/server/DecisionsFramework/Design/Form';

export interface ILayoutEntityEditor extends IEditorProps {}

export function LayoutEntityEditor({ child, path }: ILayoutEntityEditor) {
  const { editingContextId, onChange, refreshContext } = useContext(PropertyEditorContext);
  const isForRow = getEditorConfigValue(child, 'IsForRow');
  let actionLinkItem: ActionsProps[] = [];

  const onAddRowUp = useCallback(
    async (index: number) => {
      await insertRowAtViaContextId({
        editingContextId: editingContextId,
        currentRowIndex: index,
        path: path,
        insertAt: InsertColumnRowAt.Before,
      });
      refreshContext();
    },
    [refreshContext, editingContextId, path]
  );

  const onAddRowDown = useCallback(
    async (index: number) => {
      await insertRowAtViaContextId({
        editingContextId: editingContextId,
        currentRowIndex: index,
        path: path,
        insertAt: InsertColumnRowAt.After,
      });
      refreshContext();
    },
    [refreshContext, editingContextId, path]
  );

  const onAddColumnBefore = useCallback(
    async (index: number) => {
      await insertColumnAtViaContextId({
        editingContextId: editingContextId,
        currentColumnIndex: index,
        path: path,
        insertAt: InsertColumnRowAt.Before,
      });
      refreshContext();
    },
    [refreshContext, editingContextId, path]
  );

  const onAddColumnAfter = useCallback(
    async (index: number) => {
      await insertColumnAtViaContextId({
        editingContextId: editingContextId,
        currentColumnIndex: index,
        path: path,
        insertAt: InsertColumnRowAt.After,
      });
      refreshContext();
    },
    [refreshContext, editingContextId, path]
  );

  if (isForRow) {
    actionLinkItem.push({
      label: 'Add Row Before',
      onClick: onAddRowUp,
      value: 'Add Row Before',
    });
    actionLinkItem.push({
      label: 'Add Row After',
      onClick: onAddRowDown,
      value: 'Add Row After',
    });
  } else {
    actionLinkItem.push({
      label: 'Add Column Before',
      onClick: onAddColumnBefore,
      value: 'Add Column Before',
    });
    actionLinkItem.push({
      label: 'Add Column After',
      onClick: onAddColumnAfter,
      value: 'Add Column After',
    });
  }
  return (
    <ArrayEditor
      child={child}
      path={path}
      actions={actionLinkItem}
      onChange={onChange}
      containerClassName="dpc-gridlayout-editor"
      disableRemoveAction={true}
    />
  );
}
